<template>
  <div>
    <ribbon v-if="ribbonText" position="right-bottom" :fixed="true" url="" :text="ribbonText" color="#F12510"/>
    <base-nav
      v-model="showMenu"
      type="white"
      :transparent="true"
      menu-classes="justify-content-end"
      class="auth-navbar fixed-top"
    >
      <div slot="brand" class="navbar-wrapper">
        <a class="navbar-brand" href="">{{ $t("router." + routeTitle) }}</a>
      </div>

      <!-- TODO: see what we can show when login page is displayed -->
      <ul class="navbar-nav">
        <theme-settings-nav-bar />
        <language-settings-nav-bar/>
        <router-link class="nav-item" tag="li" to="/login">
          <a class="nav-link"><i class="mdi mdi_icon mdi-24px mdi-login mr-1"></i>{{ $t('navbar.login') }}</a>
        </router-link>
      </ul>
    </base-nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <!-- Slot where sub-elements placed-->
            <slot></slot>
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <sidebar-share v-if="ribbonText!==''"/>
        <footer class="footer">
          <!--
          <div class="container-fluid">
            <nav>
              <ul class="nav">
                <li class="nav-item">
                  <a
                    href="https://example.com"
                    target="_blank"
                    rel="noopener"
                    class="nav-link"
                  >
                    CompanyName
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="https://example.com/about"
                    target="_blank"
                    rel="noopener"
                    class="nav-link"
                  >
                    About Us
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="https://example.com/contact"
                    target="_blank"
                    rel="noopener"
                    class="nav-link"
                  >
                    Contacts
                  </a>
                </li>
              </ul>
            </nav>
            <div class="copyright">
              &copy; {{ year }}, made with <i class="tim-icons icon-heart-2"></i> by
              <a href="https://example.com" rel="noopener" target="_blank">CompanyName</a>
                for a better transportation.
            </div>
          </div>
          -->
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import {BaseNav} from 'src/components';
import {ZoomCenterTransition} from 'vue2-transitions';
import SidebarShare from './SidebarSharePlugin';
import LanguageSettingsNavBar from './LanguageSettingsNavBar';
import ThemeSettingsNavBar from './ThemeSettingsNavBar';

import Ribbon from 'vue-ribbon';

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
    SidebarShare,
    LanguageSettingsNavBar,
    ThemeSettingsNavBar,
    Ribbon
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      ribbonText: process.env.VUE_APP_RIBBON_TEXT
    };
  },
  computed: {
    routeTitle() {
      const {meta} = this.$route;
      return meta.title;
    },
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  mounted() {
    this.setPageClass();
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
